class HeadphoneCalculator extends HTMLElement {
  constructor() {
    super();

    this.precision = 4;
    this.type = 'mw';
    
    this.sensitivity = this.querySelector('#sensitivity');
    this.sensitivityLabel = this.querySelector('[for="sensitivity"]');
    this.impedance = this.querySelector('#impedance');
    this.loudness = this.querySelector('#loudness');

    this.requiredPower = this.querySelector('[data-value="required-power"]');
    this.requiredVoltage = this.querySelector('[data-value="required-voltage"]');
    this.requiredCurrent = this.querySelector('[data-value="required-current"]');
    
    this.equivalent = this.querySelector('[data-value="equivalent"]');
    this.equivalentLabel = this.querySelector('[data-title="equivalent"]');
    this.sensitivityUnit = this.querySelector('#sensitivity-unit');

    this.sensitivityUnit.addEventListener('change', (event) => {
      this.type = event.target.value;

      if (this.type === 'volts') {
        this.sensitivityLabel.textContent = 'Input sensitivity dB/1V';
        this.equivalentLabel.textContent = 'Equivalent spec in db/mW';
      } else {
        this.sensitivityLabel.textContent = 'Input sensitivity dB/mW';
        this.equivalentLabel.textContent = 'Equivalent spec in db/1V';
      }

      this.calculate();
    });

    const inputs = [this.sensitivity, this.impedance, this.loudness];

    inputs.forEach((input) => {
      input.addEventListener('change', () => this.calculate());
    })
  }

  calculate() {
    const sensitivity = Number.parseInt(this.sensitivity.value);
    const impedance =  Number.parseInt(this.impedance.value);
    const loudness =  Number.parseInt(this.loudness.value);

    const {
      requiredPower,
      requiredCurrent,
      requiredVoltage,
      equivalent,
    } = this.type === 'volts' ?
      this.calculateV(sensitivity, impedance, loudness) :
      this.calculateMW(sensitivity, impedance, loudness);

    this.requiredPower.textContent = requiredPower.toFixed(this.precision);
    this.requiredCurrent.textContent = requiredCurrent.toFixed(this.precision);
    this.requiredVoltage.textContent = requiredVoltage.toFixed(this.precision);
    this.equivalent.textContent = equivalent.toFixed(this.precision);
  }

  calculateMW(sensitivity, impedance, loudness) {
    const requiredPower = Math.pow(10, ((loudness - sensitivity) / 10)) / 1000;
    const requiredCurrent = Math.sqrt((requiredPower / impedance));
    const requiredVoltage = requiredCurrent * impedance;
    const equivalent = sensitivity - 10 * Math.log10((impedance  / 1000));
    
    return {
      requiredPower,
      requiredCurrent,
      requiredVoltage,
      equivalent,
    };
  }

  calculateV(sensitivity, impedance, loudness) {
    const equivalent = (sensitivity + (10 * Math.log10(impedance / 1000)) / (Math.log10(10)));
    const requiredPower = Math.pow(10, ((loudness - equivalent) / 10)) / 1000;
    const requiredCurrent = Math.sqrt((requiredPower / impedance));
    const requiredVoltage = requiredCurrent * impedance;

    return {
      requiredPower,
      requiredCurrent,
      requiredVoltage,
      equivalent,
    };
  }
}

customElements.define('headphone-calculator', HeadphoneCalculator);
